import { DateTimeFormatOptions, useDate } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { useAppRouter, useCheckoutState } from '../../state'

interface DueDateTextProps {
  index: number
  dueDate: string | null
  dateTimeFormatOptions?: DateTimeFormatOptions
  verboseDueToday?: boolean // used for Summary Page Variant A experiment. To remove when experiment is complete
}

export const DueDateText: FunctionComponent<DueDateTextProps> = ({ index, dueDate, dateTimeFormatOptions, verboseDueToday = false }) => {
  const { t } = useTranslation()
  const { started } = useCheckoutState()

  const { locale } = useAppRouter()
  const { formatDate } = useDate({ locale, ...(typeof dateTimeFormatOptions !== 'undefined' && dateTimeFormatOptions) })

  if ((started?.paymentUpFront ?? false) && index === 0 && !verboseDueToday) {
    return <>{t('common:dueToday')}</>
  }

  const datePrefix = verboseDueToday && index === 0 ? `${t('common:today')} - ` : ''

  return <>{`${datePrefix}${formatDate(dueDate)}`}</>
}
